"use strict";
function l(r, n) {
  r = r || 10;
  const c = new Array(r), f = new Array(r);
  let e = 0, o = 0, a;
  return n = n !== void 0 ? n : 1e3, function(w) {
    const t = Date.now(), i = f[o];
    a || (a = t), c[e] = w, f[e] = t;
    let u = o, d = 0;
    for (; u !== e; )
      d += c[u++], u = u % r;
    if (e = (e + 1) % r, e === o && (o = (o + 1) % r), t - a < n)
      return;
    const s = i && t - i;
    return s ? Math.round(d * 1e3 / s) : void 0;
  };
}
export {
  l as default
};
//# sourceMappingURL=index.es410.js.map
